<template>
  <div class="help-page">
    <div class="help-header">
      <h1>帮助中心</h1>
      <div class="search-box">
        <input
          v-model="searchKeyword"
          type="text"
          placeholder="搜索问题..."
          @keyup.enter="doSearch"
        />
        <button @click="doSearch">搜索</button>
      </div>
    </div>

    <!-- 搜索结果 -->
    <div v-if="isSearchResult" class="search-result">
      <div class="result-header">
        <h3>搜索结果：{{ searchKeyword }}</h3>
        <button @click="backToCategories" class="back-btn">返回分类</button>
      </div>
      <div v-if="searchResults.length === 0" class="empty-state">
        <p>未找到相关问题</p>
      </div>
      <div v-else class="result-list">
        <div
          v-for="item in searchResults"
          :key="item.id"
          class="result-item"
          @click="showArticleDetail(item.id)"
        >
          <div class="result-category" v-if="item.category_name">{{ item.category_name }}</div>
          <div class="result-title">{{ item.title }}</div>
          <div class="result-views">{{ item.views }}次浏览</div>
        </div>
      </div>
    </div>

    <!-- 文章详情 -->
    <div v-else-if="showDetail" class="article-detail">
      <div class="detail-header">
        <button @click="backToArticles" class="back-btn">← 返回</button>
        <div class="detail-info">
          <span v-if="currentArticle.category_name" class="detail-category">{{ currentArticle.category_name }}</span>
          <span class="detail-views">{{ currentArticle.views }}次浏览</span>
        </div>
      </div>
      <h1 class="detail-title">{{ currentArticle.title }}</h1>
      <div class="detail-content" v-html="currentArticle.content"></div>
      <div class="detail-footer">
        <p>如果没有找到您的问题，您可以联系客服获取帮助。</p>
      </div>
    </div>

    <!-- 文章列表 -->
    <div v-else-if="showArticles" class="articles-section">
      <div class="section-header">
        <button @click="backToCategories" class="back-btn">← 返回</button>
        <h2>{{ currentCategory.name }}</h2>
      </div>
      <div class="articles-list">
        <div
          v-for="article in articles"
          :key="article.id"
          class="article-item"
          @click="showArticleDetail(article.id)"
        >
          <div class="article-title">{{ article.title }}</div>
          <div class="article-meta">
            <span>{{ article.views }}次浏览</span>
            <span>{{ article.update_time }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 分类列表 -->
    <div v-else class="categories-section">
      <h2>常见问题分类</h2>
      <div class="categories-grid">
        <div
          v-for="category in displayCategories"
          :key="category.id"
          class="category-card"
          @click="selectCategory(category)"
        >
          <div class="category-icon" v-html="getCategoryIcon(category.icon)"></div>
          <div class="category-name">{{ category.name }}</div>
          <div class="category-count">{{ category.article_count }}篇</div>
        </div>
      </div>

      <!-- 未成年人保护投诉举报 -->
      <div class="minor-protection-card">
        <h3>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>
          未成年人保护投诉举报
        </h3>
        <p>依据《未成年人网络保护条例》，本平台设立未成年人保护专项投诉举报渠道。如您发现危害未成年人身心健康的内容、诱导沉迷的功能，或未成年人未经监护人同意进行充值消费，请通过客服电话联系我们，平台将在受理后及时核实处置。</p>
        <div class="minor-contact">
          <span>客服电话（未成年人保护专线）</span>
          <strong>13810795803</strong>
        </div>
      </div>

      <!-- 热门问题 -->
      <div class="hot-questions">
        <h3>热门问题</h3>
        <div class="hot-list">
          <div
            v-for="item in displayHotArticles"
            :key="item.id"
            class="hot-item"
            @click="showArticleDetail(item.id)"
          >
            <span class="hot-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
            </span>
            <span class="hot-title">{{ item.title }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部导航 -->
    <div class="footer-nav">
      <router-link to="/" class="nav-item">首页</router-link>
      <router-link to="/profile" class="nav-item">个人中心</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelpPage',
  data() {
    return {
      searchKeyword: '',
      searchResults: [],
      isSearchResult: false,
      showArticles: false,
      showDetail: false,
      currentCategory: {},
      currentArticle: {},
      articles: [],
      categories: [
        { id: 'account', name: '账号相关', icon: 'account' },
        { id: 'coin', name: '金币充值', icon: 'coin' },
        { id: 'book', name: '阅读问题', icon: 'book' },
        { id: 'vip', name: 'VIP特权', icon: 'other' },
        { id: 'submission', name: '投稿相关', icon: 'submission' },
        { id: 'teenager', name: '青少年模式', icon: 'other' },
        { id: 'realname', name: '实名认证', icon: 'other' },
        { id: 'payment', name: '支付问题', icon: 'coin' }
      ],
      hotIds: ['how-to-register', 'how-to-recharge', 'how-to-read', 'vip-privileges', 'what-is-teenager-mode', 'how-to-submit'],
      allArticles: [
        {
          id: 'how-to-register',
          title: '如何注册账号？',
          category: 'account',
          category_name: '账号相关',
          views: 1205,
          update_time: '2026-01-01',
          content: '<p>1. 打开网站或App，点击右上角“登录 / 注册”。</p><p>2. 输入手机号并获取验证码。</p><p>3. 设置登录密码（至少6位）。</p><p>4. 点击“注册”完成账号创建，注册成功后会自动登录。</p><p>温馨提示：一个手机号只能注册一个账号，建议使用常用手机号以便找回密码。</p>'
        },
        {
          id: 'how-to-reset-password',
          title: '忘记密码怎么办？',
          category: 'account',
          category_name: '账号相关',
          views: 892,
          update_time: '2026-01-01',
          content: '<p>1. 在登录页点击“忘记密码”。</p><p>2. 输入手机号获取验证码。</p><p>3. 设置新密码并确认。</p><p>4. 使用新密码登录即可。</p>'
        },
        {
          id: 'how-to-recharge',
          title: '如何充值金币？',
          category: 'coin',
          category_name: '金币充值',
          views: 2103,
          update_time: '2026-01-01',
          content: '<p>1. 登录后点击顶部导航“金币充值”。</p><p>2. 选择充值套餐。</p><p>3. 选择支付方式（微信/支付宝）。</p><p>4. 完成支付后金币即时到账。</p><p>充值比例：100金币 = 1元，充值越多赠送越多。</p>'
        },
        {
          id: 'coin-usage',
          title: '金币可以用来做什么？',
          category: 'coin',
          category_name: '金币充值',
          views: 756,
          update_time: '2026-01-01',
          content: '<p>金币可用于购买单章付费漫画、打赏作者、参与平台活动等。</p><p>部分VIP章节仍需单独购买金币解锁。</p>'
        },
        {
          id: 'how-to-read',
          title: '如何阅读漫画？',
          category: 'book',
          category_name: '阅读问题',
          views: 1856,
          update_time: '2026-01-01',
          content: '<p>1. 在首页或分类页找到想看的漫画。</p><p>2. 点击封面进入详情页。</p><p>3. 选择章节即可开始阅读。</p><p>阅读进度会自动保存，下次打开可从历史记录继续。</p>'
        },
        {
          id: 'reading-history',
          title: '阅读记录会保存多久？',
          category: 'book',
          category_name: '阅读问题',
          views: 543,
          update_time: '2026-01-01',
          content: '<p>登录用户的阅读记录会长期保存，未登录游客仅保存在当前设备本地。</p><p>建议登录账号以同步多设备阅读进度。</p>'
        },
        {
          id: 'vip-privileges',
          title: 'VIP有哪些特权？',
          category: 'vip',
          category_name: 'VIP特权',
          views: 1342,
          update_time: '2026-01-01',
          content: '<p>VIP会员可享受以下特权：</p><ul><li>海量VIP专属漫画免费看</li><li>免除广告打扰</li><li>抢先阅读最新章节</li><li>专属VIP标识</li><li>优先客服响应</li></ul><p>进入顶部导航“开通VIP”即可选择套餐购买。</p>'
        },
        {
          id: 'how-to-submit',
          title: '如何成为作者？',
          category: 'submission',
          category_name: '投稿相关',
          views: 430,
          update_time: '2026-01-01',
          content: '<p>1. 登录后点击顶部导航“投稿”。</p><p>2. 填写作品基本信息并上传封面。</p><p>3. 添加章节并上传图片。</p><p>4. 提交审核，通常1-3个工作日内完成。</p>'
        },
        {
          id: 'what-is-teenager-mode',
          title: '什么是青少年模式？',
          category: 'teenager',
          category_name: '青少年模式',
          views: 987,
          update_time: '2026-01-01',
          content: '<p>青少年模式是为保护未成年用户设计的功能。</p><p>开启后将过滤部分内容、限制夜间使用时段，提供更健康的阅读体验。</p><p>可在个人头像下拉菜单中进入“青少年模式”进行设置。</p>'
        },
        {
          id: 'why-realname',
          title: '为什么要实名认证？',
          category: 'realname',
          category_name: '实名认证',
          views: 621,
          update_time: '2026-01-01',
          content: '<p>实名认证可保障账号安全、享受更多会员权益，并符合国家相关规定。</p><p>进入个人中心 → 实名认证，填写真实姓名和身份证号并验证即可。</p><p>您的个人信息会严格保密。</p>'
        },
        {
          id: 'payment-failed',
          title: '支付失败怎么办？',
          category: 'payment',
          category_name: '支付问题',
          views: 1104,
          update_time: '2026-01-01',
          content: '<p>1. 检查网络连接是否稳定。</p><p>2. 确认支付账户余额充足。</p><p>3. 尝试更换支付方式。</p><p>4. 若仍失败，请联系客服并提供订单信息。</p>'
        }
      ]
    }
  },
  computed: {
    displayCategories() {
      return this.categories.map(c => ({
        ...c,
        article_count: this.allArticles.filter(a => a.category === c.id).length
      }));
    },
    displayHotArticles() {
      return this.hotIds
        .map(id => this.allArticles.find(a => a.id === id))
        .filter(Boolean);
    }
  },
  methods: {
    selectCategory(category) {
      this.currentCategory = category;
      this.articles = this.allArticles.filter(a => a.category === category.id);
      this.showArticles = true;
      this.isSearchResult = false;
      this.showDetail = false;
    },
    showArticleDetail(id) {
      const article = this.allArticles.find(a => a.id === id);
      if (!article) return;
      this.currentArticle = article;
      this.showDetail = true;
      this.showArticles = false;
      this.isSearchResult = false;
      this.$nextTick(() => window.scrollTo(0, 0));
    },
    backToCategories() {
      this.showArticles = false;
      this.showDetail = false;
      this.isSearchResult = false;
      this.searchKeyword = '';
      this.searchResults = [];
    },
    backToArticles() {
      this.showDetail = false;
      this.showArticles = true;
    },
    doSearch() {
      const keyword = this.searchKeyword.trim();
      if (!keyword) return;
      const lower = keyword.toLowerCase();
      this.searchResults = this.allArticles.filter(a => {
        const inTitle = a.title.toLowerCase().includes(lower);
        const inContent = this.stripHtml(a.content).toLowerCase().includes(lower);
        return inTitle || inContent;
      });
      this.isSearchResult = true;
      this.showArticles = false;
      this.showDetail = false;
    },
    stripHtml(html) {
      if (!html) return '';
      return html.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();
    },
    getCategoryIcon(icon) {
      const stroke = "stroke='currentColor' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'";
      const icons = {
        'account': `<svg viewBox='0 0 24 24' fill='none' ${stroke}><circle cx='12' cy='8' r='4'/><path d='M4 21c0-4 4-6 8-6s8 2 8 6'/></svg>`,
        'coin': `<svg viewBox='0 0 24 24' fill='none' ${stroke}><circle cx='12' cy='12' r='9'/><path d='M12 7v10M9.5 9.5h3.5a1.5 1.5 0 0 1 0 3h-2a1.5 1.5 0 0 0 0 3H14'/></svg>`,
        'book': `<svg viewBox='0 0 24 24' fill='none' ${stroke}><path d='M4 19.5A2.5 2.5 0 0 1 6.5 17H20V3H6.5A2.5 2.5 0 0 0 4 5.5v14z'/><path d='M4 19.5A2.5 2.5 0 0 0 6.5 22H20v-5'/></svg>`,
        'submission': `<svg viewBox='0 0 24 24' fill='none' ${stroke}><path d='M12 20h9'/><path d='M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z'/></svg>`,
        'other': `<svg viewBox='0 0 24 24' fill='none' ${stroke}><circle cx='12' cy='12' r='9'/><path d='M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3'/><path d='M12 17h.01'/></svg>`
      };
      return icons[icon] || `<svg viewBox='0 0 24 24' fill='none' ${stroke}><rect x='3' y='3' width='18' height='18' rx='2'/><path d='M9 8h6M9 12h6M9 16h4'/></svg>`;
    }
  }
}
</script>

<style scoped>
.help-page {
  width: 50vw;
  min-width: 800px;
  max-width: none;
  min-height: 100vh;
  margin: 0 auto;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 20px;
  padding: 30px;
}

.help-header {
  text-align: center;
  padding: 20px 0 30px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 30px;
}

.help-header h1 {
  font-size: 28px;
  color: var(--text);
  margin-bottom: 20px;
}

.search-box {
  display: flex;
  max-width: 500px;
  margin: 0 auto;
  gap: 10px;
}

.search-box input {
  flex: 1;
  padding: 12px 16px;
  background: var(--surface-2);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 14px;
}

.search-box input:focus {
  outline: none;
  border-color: var(--brand);
}

.search-box button {
  padding: 12px 24px;
  background: var(--brand);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.search-box button:hover {
  background: var(--brand-hover);
  transform: translateY(-1px);
}

.categories-section h2 {
  font-size: 20px;
  color: var(--text);
  margin-bottom: 20px;
}

.categories-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
  margin-bottom: 40px;
}

.category-card {
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 24px 16px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
}

.category-card:hover {
  transform: translateY(-4px);
  border-color: var(--brand);
}

.category-icon {
  width: 40px;
  height: 40px;
  margin: 0 auto 12px;
  color: var(--brand);
  display: flex;
  align-items: center;
  justify-content: center;
}
.category-icon svg {
  width: 34px;
  height: 34px;
}

.category-name {
  font-size: 16px;
  font-weight: 600;
  color: var(--text);
  margin-bottom: 8px;
}

.category-count {
  font-size: 12px;
  color: var(--text-faint);
}

.hot-questions {
  margin-top: 30px;
}

/* 未成年人保护投诉举报 */
.minor-protection-card {
  margin-top: 30px;
  padding: 22px;
  background: var(--surface-2);
  border: 1px solid rgba(79, 172, 254, 0.3);
  border-radius: 14px;
}

.minor-protection-card h3 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  color: var(--brand);
  margin: 0 0 12px 0;
}

.minor-protection-card h3 svg {
  width: 18px;
  height: 18px;
}

.minor-protection-card p {
  font-size: 13px;
  line-height: 1.8;
  color: var(--text-dim);
  margin: 0 0 14px 0;
}

.minor-contact {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  background: var(--surface-3);
  border-radius: 10px;
}

.minor-contact span {
  font-size: 13px;
  color: var(--text-dim);
}

.minor-contact strong {
  font-size: 17px;
  color: var(--brand);
  letter-spacing: 0.5px;
}

.hot-questions h3 {
  font-size: 18px;
  color: var(--text);
  margin-bottom: 16px;
}

.hot-list {
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 16px;
}

.hot-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.2s;
}

.hot-item:hover {
  background: var(--brand-soft);
}

.hot-icon {
  width: 18px;
  height: 18px;
  color: var(--warning);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.hot-icon svg {
  width: 100%;
  height: 100%;
}

.hot-title {
  font-size: 14px;
  color: var(--text);
  flex: 1;
}

/* 搜索结果 */
.search-result {
  padding: 20px 0;
}

.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.result-header h3 {
  font-size: 18px;
  color: var(--text);
}

.result-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.result-item {
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.3s;
}

.result-item:hover {
  border-color: var(--brand);
  background: var(--surface-3);
}

.result-category {
  font-size: 12px;
  color: var(--brand);
  margin-bottom: 8px;
}

.result-title {
  font-size: 16px;
  font-weight: 500;
  color: var(--text);
  margin-bottom: 8px;
}

.result-views {
  font-size: 12px;
  color: var(--text-faint);
}

/* 文章列表 */
.section-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.section-header h2 {
  font-size: 20px;
  color: var(--text);
  margin: 0;
}

.articles-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.article-item {
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.3s;
}

.article-item:hover {
  border-color: var(--brand);
  background: var(--surface-3);
}

.article-title {
  font-size: 16px;
  font-weight: 500;
  color: var(--text);
  margin-bottom: 8px;
}

.article-meta {
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: var(--text-faint);
}

/* 文章详情 */
.article-detail {
  padding: 20px 0;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.detail-info {
  display: flex;
  gap: 16px;
  align-items: center;
}

.detail-category {
  background: var(--brand);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
}

.detail-views {
  font-size: 12px;
  color: var(--text-faint);
}

.detail-title {
  font-size: 24px;
  color: var(--text);
  margin-bottom: 24px;
  line-height: 1.5;
}

.detail-content {
  font-size: 15px;
  line-height: 1.8;
  color: #1a2f4a;
  padding: 24px;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 12px;
  margin-bottom: 30px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.detail-content :deep(h2),
.detail-content :deep(h3),
.detail-content :deep(h4) {
  color: #0c1929;
  margin: 20px 0 12px;
}

.detail-content :deep(p) {
  margin: 12px 0;
  color: #1a2f4a;
}

.detail-content :deep(ul),
.detail-content :deep(ol) {
  margin: 12px 0;
  padding-left: 24px;
}

.detail-content :deep(li) {
  margin: 8px 0;
  color: #1a2f4a;
}

.detail-content :deep(strong) {
  color: #0c1929;
  font-weight: 600;
}

.detail-footer {
  text-align: center;
  padding: 20px;
  background: var(--brand-soft);
  border: 1px solid var(--border);
  border-radius: 12px;
  color: var(--text-dim);
  font-size: 14px;
}

/* 通用按钮 */
.back-btn {
  padding: 8px 16px;
  background: var(--surface-3);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.back-btn:hover {
  background: var(--brand-soft);
  border-color: var(--brand);
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: var(--text-dim);
}

/* 底部导航 */
.footer-nav {
  display: flex;
  justify-content: center;
  gap: 40px;
  padding: 30px 0;
  margin-top: 40px;
  border-top: 1px solid var(--border);
}

.nav-item {
  color: var(--brand);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s;
}

.nav-item:hover {
  color: var(--brand-deep);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .help-page {
    width: 70vw;
    min-width: 600px;
  }
}

@media (max-width: 768px) {
  .help-page {
    width: 95vw;
    min-width: auto;
    padding: 20px;
    margin: 10px auto;
  }

  .categories-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .search-box {
    flex-direction: column;
  }

  .result-header {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
}
</style>
